import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

import ru from 'vuetify/es5/locale/ru'

export default new Vuetify({
    lang: {
        locales: {ru},
        current: 'ru',
    },
    theme: {
        themes: {
            light: {
                green: '#5aae41',
                primary: '#5aae41',
            },
            dark: {
                green: '#5aae41',
                primary: '#5aae41',
            },
        },
    },
});
